import api from '@/logic/api'

export const PRIVACY_POLICY_PAGE_ID = 'privacy-policy'
export const TERMS_OF_SERVICE_PAGE_ID = 'terms-of-service'
export const IMPRINT_PAGE_ID = 'imprint'

export default {
  getPages: () => api.get('/pages'),
  findPage: (id) => api.get(`/pages/${encodeURIComponent(id)}`),
  findPublicPage(id, profileId) {
    const path = [`/public/pages/${encodeURIComponent(id)}`]
    if (profileId) {
      path.push(encodeURIComponent(profileId))
    }
    return api.get(path.join('/'))
  },
  getTos: () => api.get('/tos'),
  getPrivacyPolicyForConfirmation: () => api.get('/privacy-policy'),
}
